import { ITributosRetidosTableData } from "@/views/contabil/dashboardTributacao/widgets/TributosRetidos/types";
import {
  ITributosRetidosEmpresaResponse,
  ITributosRetidosResponse
} from "../../requests/types";
import EmpresaMapper from "@/common/contabil/EmpresaMapperAdapter";

export default class TributosRetidos {
  constructor(readonly response: ITributosRetidosResponse | undefined) {}

  formatToDataSource(
    empresas: ITributosRetidosEmpresaResponse[] | undefined
  ): ITributosRetidosTableData[] {
    return (
      empresas?.map((empresa) => {
        if (!empresa.diferencas)
          return {
            empresa: EmpresaMapper.toEntity(empresa),
            id: ""
          };

        const anos = Object.entries(empresa.diferencas).map(
          ([year, value]) => ({
            year,
            data: value.total
          })
        );

        const data = anos.reduce(
          (obj, item) => Object.assign(obj, { [item.year]: item.data }),
          {}
        );

        return {
          empresa: EmpresaMapper.toEntity(empresa),
          id: empresa.id,
          ...data
        };
      }) || []
    );
  }

  handleAlertTotalDeCreditos(): boolean {
    return (this.response?.creditoDisponivel || 0) > 0;
  }

  handleAlertTributosNaoUtilizados(): boolean {
    return (this.response?.totalDiferencas || 0) > 0;
  }
}
